<a class="folder-button"

   mat-flat-button
   matTooltip="Click here to browse the folder contents."

   [ngStyle]="style"
   (click)="handleFolderClick($event, element)">
  <mat-icon class="material-icons-outlined"
            aria-hidden="false"
            aria-label="Example home icon">
    folder
  </mat-icon>
  {{ element.label || element.name }}
</a>

<pre>aQ                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     
  {{style | json}}
</pre>
